import { type ILayerBehavior, type ILayerProps, type ITextLayerProps } from '@/version-types';

type Behaviors = Pick<ILayerBehavior, 'checkIsTextTransform' | 'isTextEditable'>;

export const createGetterBehaviors = (identity: string) => {
    const behaviors: Behaviors = {
        /**
         * 判断是否是变形文字
         *
         * @param layer - 图层属性
         */
        checkIsTextTransform(layer: ILayerProps) {
            const layerData = layer.data as ITextLayerProps;
            return !!layerData.shapeExtension;
        },

        /**
         * 判断图层是否支持文本编辑
         */
        isTextEditable() {
            return true;
        },
    };

    return behaviors;
};
